export const extConfig = {
    muro: false,
    bold: true,
    italic: true,
    strikethrough: true,
    underline: true,
    bulletList: false,
    orderedList: false,
    horizontalRuler: false,
    link: true,
    emote: true,
    deviation: {
        defaultWidth: 430,
        formMaxWidth: 780,
        canLink: true,
        canAlign: true,
        canConfigure: true,
        canResize: true
    },
    gallery: false,
    anchor: false,
    blockDragging: false,
    blockquote: false,
    heading: false,
    mention: true,
    paste: true,
    textAlignment: false,
    textColor: false,
    textFont: false,
    textHighlight: false,
    history: true,
    allowUploads: false,
    spinner: true,
    gif: false,
    indent: false,
    daVideo: false,
    hashtag: true,
    characterCount: true
};

//# sourceMappingURL=config.js.map